import classNames from 'classnames';
import React from 'react';
import NorskFlagg from './NorskFlagg';
import './Skilt.scss';

export enum Skiltfarge {
    Ordinaert = 'skilt--farge-ordinaert',
    RallyTrialEnduro = 'skilt--farge-rallyTrialEnduro',
    UtenforOffentligVeg = 'skilt--farge-utenforOffentligVeg',
    VarebilKlasse2 = 'skilt--farge-varebilKlasse2',
}

export enum Skiltstorrelse {
    SS = 'skilt--storrelse-ss',
    SH = 'skilt--storrelse-sh',
    LH = 'skilt--storrelse-lh',
    LS = 'skilt--storrelse-ls',
    US = 'skilt--storrelse-us',
    ST = 'skilt--storrelse-st',
}
type SkiltProps = {
    farge?: Skiltfarge;
    storrelse?: Skiltstorrelse;
    tegnkombinasjon: string;
};

export const Skilt = ({
    farge = Skiltfarge.Ordinaert,
    storrelse = Skiltstorrelse.SS,
    tegnkombinasjon,
}: SkiltProps) => {
    return (
        <div
            className={classNames(
                'skilt',
                farge,
                storrelse,
                'spacing-bottom--small',
            )}
            aria-hidden
        >
            {!(
                farge === Skiltfarge.UtenforOffentligVeg ||
                farge === Skiltfarge.RallyTrialEnduro
            ) && <Nasjonalitet />}
            <div className="kjennemerke">
                {(storrelse === Skiltstorrelse.SH ||
                    storrelse === Skiltstorrelse.LH ||
                    storrelse === Skiltstorrelse.US) && (
                    <>
                        <p data-hj-suppress={true}>
                            {tegnkombinasjon.substring(0, 3)}
                        </p>
                        <p data-hj-suppress={true}>
                            {tegnkombinasjon
                                .substring(3)
                                .replace(/ /g, '\u00a0') || '\u00a0'}
                        </p>
                    </>
                )}

                {(storrelse === Skiltstorrelse.SS ||
                    storrelse === Skiltstorrelse.LS ||
                    storrelse === Skiltstorrelse.ST) && (
                    <p data-hj-suppress={true}>{tegnkombinasjon}</p>
                )}
            </div>
        </div>
    );
};

const Nasjonalitet: React.FC = () => (
    <div className="nasjonalitet">
        <NorskFlagg className="flagg" />
        <span>N</span>
    </div>
);
